/* ============================================================
   PINEAPPLE MAN THEME — behavior.
   Vanilla JS: header shadow, mobile menu, cart drawer (Shopify
   AJAX cart + Section Rendering API), quantity steppers,
   add-to-cart, toast. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.PM_ROUTES && window.PM_ROUTES.root) || '/';
  var CART_ADD = (window.PM_ROUTES && window.PM_ROUTES.cartAdd) || '/cart/add.js';
  var CART_CHANGE = (window.PM_ROUTES && window.PM_ROUTES.cartChange) || '/cart/change.js';
  var CART_JS = (window.PM_ROUTES && window.PM_ROUTES.cart) || '/cart.js';

  /* ---------------- helpers ---------------- */
  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var symbol = (window.PM_MONEY && window.PM_MONEY.symbol) || '$';
    return symbol + (cents / 100).toFixed(2);
  }

  /* ---------------- toast ---------------- */
  var toastTimer = null;
  function toast(message) {
    var el = qs('[data-pm-toast]');
    if (!el) return;
    qs('[data-pm-toast-text]', el).textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- header ---------------- */
  function initHeader() {
    var header = qs('[data-pm-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- mobile menu ---------------- */
  function initMenu() {
    var open = function () {
      document.body.classList.add('pm-menu-open');
      var close = qs('[data-pm-menu-close]');
      if (close) close.focus();
    };
    var close = function () { document.body.classList.remove('pm-menu-open'); };

    qsa('[data-pm-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    qsa('[data-pm-menu-close], .pm-menu-backdrop, .pm-mobile-menu__nav a').forEach(function (b) {
      b.addEventListener('click', close);
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var mq = window.matchMedia('(min-width: 901px)');
    var onBp = function () { if (mq.matches) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onBp);
  }

  /* ---------------- cart drawer ---------------- */
  function openCart() { document.body.classList.add('pm-cart-open'); }
  function closeCart() { document.body.classList.remove('pm-cart-open'); }

  function bindCartUI(scope) {
    qsa('[data-pm-cart-close], .pm-cart-backdrop', scope).forEach(function (b) {
      b.addEventListener('click', closeCart);
    });
    /* drawer line-item steppers */
    qsa('[data-pm-line]', scope).forEach(function (row) {
      var key = row.getAttribute('data-pm-line');
      var valueEl = qs('[data-pm-stepper-value]', row);
      var qty = parseInt(valueEl ? valueEl.textContent : '1', 10) || 1;
      qsa('[data-pm-stepper-dec]', row).forEach(function (b) {
        b.addEventListener('click', function () { changeLine(key, Math.max(0, qty - 1)); });
      });
      qsa('[data-pm-stepper-inc]', row).forEach(function (b) {
        b.addEventListener('click', function () { changeLine(key, qty + 1); });
      });
      qsa('[data-pm-line-remove]', row).forEach(function (b) {
        b.addEventListener('click', function () { changeLine(key, 0); });
      });
    });
  }

  function refreshCartSection() {
    return fetch(ROOT + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var holder = qs('#shopify-section-cart-drawer');
        if (holder && sections['cart-drawer']) {
          var tpl = document.createElement('div');
          tpl.innerHTML = sections['cart-drawer'];
          var fresh = tpl.querySelector('.shopify-section') || tpl.firstElementChild;
          holder.innerHTML = fresh ? fresh.innerHTML : sections['cart-drawer'];
          bindCartUI(holder);
        }
        return fetch(CART_JS).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa('[data-pm-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', String(cart.item_count));
        });
        return cart;
      });
  }

  function changeLine(key, quantity) {
    fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCartSection);
  }

  function initCart() {
    qsa('[data-pm-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    bindCartUI(document);
  }

  /* ---------------- buy block ---------------- */
  function initBuyBlocks() {
    qsa('[data-pm-product-form]').forEach(function (form) {
      var priceCents = parseInt(form.getAttribute('data-price-cents') || '0', 10);
      var qtyInput = qs('[data-pm-qty-input]', form);
      var valueEl = qs('[data-pm-stepper-value]', form);
      var totalEl = qs('[data-pm-total]', form);
      var button = qs('[data-pm-add]', form);
      var productTitle = form.getAttribute('data-product-title') || 'item';

      function getQty() { return parseInt(qtyInput.value, 10) || 1; }

      /* The displayed total includes the selected delivery estimate, matching
         the design. Shipping is still charged for real at checkout. */
      function deliveryCents() {
        var selected = qs('[data-pm-delivery][aria-pressed="true"]', form);
        if (!selected) return 0;
        var priceEl = qs('.pm-delivery-opt__price', selected);
        if (!priceEl) return 0;
        var amount = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
        return isNaN(amount) ? 0 : Math.round(amount * 100);
      }

      function setQty(n) {
        var clamped = Math.max(1, Math.min(10, n));
        qtyInput.value = clamped;
        if (valueEl) valueEl.textContent = clamped;
        if (totalEl && priceCents) {
          totalEl.textContent = formatMoney(priceCents * clamped + deliveryCents());
        }
      }

      qsa('[data-pm-stepper-dec]', form).forEach(function (b) {
        b.addEventListener('click', function () { setQty(getQty() - 1); });
      });
      qsa('[data-pm-stepper-inc]', form).forEach(function (b) {
        b.addEventListener('click', function () { setQty(getQty() + 1); });
      });

      /* delivery selector — informational only; shipping is set at checkout */
      qsa('[data-pm-delivery]', form).forEach(function (opt) {
        opt.addEventListener('click', function () {
          qsa('[data-pm-delivery]', form).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          opt.setAttribute('aria-pressed', 'true');
          setQty(getQty());
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = getQty();
        var data = new FormData(form);
        button.setAttribute('aria-disabled', 'true');
        fetch(CART_ADD, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            toast('Added ' + qty + ' ' + productTitle + (qty > 1 ? 's' : '') + ' to your cart');
            var label = qs('[data-pm-add-label]', form);
            if (label) {
              var original = label.innerHTML;
              /* Swap the cart glyph for a tick rather than replacing the whole
                 label, which would drop the icon entirely. */
              label.innerHTML =
                '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M4 12.5l5 5L20 6" /></svg> Added!';
              setTimeout(function () { label.innerHTML = original; }, 1800);
            }
            return refreshCartSection();
          })
          .catch(function (err) {
            toast((err && err.description) || 'Could not add to cart');
          })
          .then(function () { button.removeAttribute('aria-disabled'); });
      });

      setQty(getQty());
    });
  }

  /* ---------------- init ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMenu();
    initCart();
    initBuyBlocks();
  });
})();
